<div [ngClass]="{'ro-form-control-errors' : hasErrors}">
  <ng-content></ng-content>
  <ng-container *ngIf="hasErrors">
    <span class="tw-block tw-text-sm tw-truncate xl:tw-text-red-500">{{ fieldError }}</span>
  </ng-container>
</div>
